/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_Pay_Per_Use_DescInputs */



/**
* | output |
* | --- |
* | "Your Starter plan bills AI token usage at provider cost with no markup. oneAI Standard is free in the oneAI app as your fallback model; through an API key or..." |
*
* @param {Usage_Tab_Pay_Per_Use_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_pay_per_use_desc = /** @type {((inputs?: Usage_Tab_Pay_Per_Use_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Pay_Per_Use_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Starter-Plan berechnet die KI-Token-Nutzung zum Anbieterpreis ohne Aufschlag. oneAI Standard ist in der oneAI-App als Fallback-Modell kostenlos; über einen API-Schlüssel oder den Microsoft-Teams-Bot wird es wie jedes andere Modell berechnet. Alle Nutzungen erscheinen auf Ihrer nächsten Rechnung.")
	return /** @type {LocalizedString} */ ("Your Starter plan bills AI token usage at provider cost with no markup. oneAI Standard is free in the oneAI app as your fallback model; through an API key or the Microsoft Teams bot it is billed like every other model. All usage appears on your next invoice.")
});